import {Avatar, Comment, Form, Input} from "antd";
import styled from "styled-components";
import {projectStatusCodeMap} from "../../../../components/ProjectStatusCodeMap";
import {isViewOnlyOrExternalView} from "../../../../utils/UserInfo";
import React, {Fragment, useEffect, useState} from "react";
import CommentDialog from "../../../../components/CommentsPopUp";
import {addJobJournalComment, getJobJournalCommentsById} from "../../../../api";
import { UserOutlined } from '@ant-design/icons';

const {TextArea} = Input;
const btnstyle = {
    float: "right",
    color: "white",
    backgroundColor: "#0CA0DA",
    marginTop: "-15px",
    marginRight: "15px",
    paddingTop: "0px",
    paddingBottom: "0px",
};
const commentsStyle = {
    display: "block",
    margin: "15px",
};
const commentcss = {
    marginLeft: "50px",
    marginTop: "-30px",
};
const CommentContainer = styled.div`
    overflow-y : scroll;
    overflow-x: hidden;
    height : 200px;
    max-width: 800px;
    padding-left: 0px;
    font-size:12px;
`;


const Editor = ({onChange, addComment, disable, value,project,jobJournalRow, ...props}) => (
    <div>
        {project.projectStatus !== projectStatusCodeMap["CLOSED"] &&
        !isViewOnlyOrExternalView() &&
        <Form.Item>
            <TextArea id="txt" value={value} class="col-xs-12 col-md-4" rows={2} onChange={onChange} maxLength={600}
                      style={{maxWidth: "98%"}} placeholder="Add comments "/>
        </Form.Item>
        }
        {project.projectStatus !== projectStatusCodeMap["CLOSED"] &&
        !isViewOnlyOrExternalView() &&
        <Form.Item>
            <button id="btSubmit" style={btnstyle} htmlType="submit" onClick={addComment}
                    disabled={disable}>
                Post
            </button>
        </Form.Item>
        }

    </div>
);

export default (function JobJournalComments(props) {const {projectId, onClose,project,formId} = props;
    const [value, setValue] = useState('');
    const [comments, setComments] = useState([]);
    const [disable, setDisable] = useState(true);

    useEffect(() => {
        async function getCommentsById(projectId,formId) {
            const result = await getJobJournalCommentsById(projectId,formId);
            setComments(result);
        }
        getCommentsById(projectId,formId);
    }, []);

    async function addComment(event) {
        // let commentRequest = new Object();
        // commentRequest.projectId = projectId;
        // commentRequest.formId = formId;
        // commentRequest.comments = value;
        await addJobJournalComment(value, projectId,formId);
        setValue('');
        setDisable(true);
        setComments(await getJobJournalCommentsById(projectId,formId));
    }

    const handleChange = event => {
        setValue(event.target.value);
        setDisable(false);
    };

    return (
        <Fragment>
            <div>
                {/*<CommentDialog onClose={onClose}  />*/}
                <div>
                    <Comment
                        content={
                            <Editor
                                disable={disable}
                                addComment={addComment}
                                onChange={handleChange}
                                value={value}
                                props={props}
                                project={props.project}
                                jobJournalRow={props.jobJournalRow}
                            />
                        }
                    />
                </div>
                <CommentContainer>
                    {
                        comments.map(user => (
                            <div style={commentsStyle}>
                                <Avatar size="small" icon={<UserOutlined />}/>
                                <div style={commentcss}>
                                    <span> {user.firstName} </span>
                                    <span> {user.lastName} </span><span
                                    style={{marginLeft: "400px"}}> {user.lastModifiedDateString}  </span>
                                    <div style={{wordWrap: "break-word"}}>{user.comments}  </div>
                                </div>

                            </div>
                        ))}
                </CommentContainer>
            </div>
        </Fragment>

    )

})
